import React from 'react'
import { Trans } from 'react-i18next'
import styled from 'styled-components'
// @ts-ignore
import { sys } from '@netbasequid/theme'
// @ts-ignore
import { AutomationId, AUTO_ATTR_KEY } from 'utils/automationUtil'
import CountType, { CountTypeStrings } from 'enums/CountType'

const StyledName = styled.span.attrs({
  [AUTO_ATTR_KEY]: AutomationId.insightModal.insightContent.overview.selectedTerm
})`
  font-weight: ${sys.fontWeight.semibold};
  margin-left: 3px;
  margin-right: 3px;
`

const Title = ({
  countType,
  selectionName
}: {
  countType: CountTypeStrings
  selectionName: React.ReactNode
}) => {
  let titleKey = ''
  switch (countType) {
    case CountType.MENTIONS:
      titleKey = 'mentionsBy'
      break
    case CountType.POSTS:
      titleKey = 'postsBy'
      break
    default:
  }

  return (
    <Trans i18nKey={titleKey} values={{ name: selectionName }}>
      <StyledName />
    </Trans>
  )
}

export default Title
